module.exports = __webpack_public_path__ + "copy-16.e16085e8.svg";